export default "__VITE_ASSET__e0bbfd5f__"